module.exports = "<div class=\"footerMain\">\n  <!--<p>User Account Information</p>-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/appfooter/appfooter.html
// module id = 27
// module chunks = 0